import api from '@/api/talent'

const state = {

}

const actions = {
  getCompanyTalentCandidateList (context, params) {
    return api.getCompanyTalentCandidateList(params)
  },
  getTalentCandidateIdList (context, params) {
    return api.getTalentCandidateIdList(params)
  },
  getTalentCandidateInfo (context, { candidateId }) {
    return api.getTalentCandidateInfo(candidateId)
  },
  getTalentFilterParentGroup () {
    return api.getTalentFilterParentGroup()
  },
  getTalentFilterGroup (context, { groupId }) {
    return api.getTalentFilterGroup(groupId)
  },
  createTalentFilterGroup (context, params) {
    return api.createTalentFilterGroup(params)
  },
  updateTalentFilterGroup (context, params) {
    return api.updateTalentFilterGroup(params)
  },
  searchTalentFilterGroup ({ commit }, params) {
    return api.searchTalentFilterGroup(params)
  },
  searchTalentFilterGroupList ({ commit }, params) {
    return api.searchTalentFilterGroupList(params)
  },
  updateTalentFilterGroupInfo ({ commit }, group) {
    return api.updateTalentFilterGroupInfo(group)
  },
  deleteTalentFilterGroup ({ commit }, group) {
    return api.deleteTalentFilterGroup(group)
  },
  createTalentPoolComment (context, params) {
    return api.createTalentPoolComment(params)
  },
  createTalentCandidateShareLinkCode (context, params) {
    return api.createTalentCandidateShareLinkCode(params)
  },
  exportTalentCandidateProfilePdf (context, params) {
    return api.exportTalentCandidateProfilePdf(params)
  },
  getExportTalentCandidateProfilePdfTaskStatus (context, params) {
    return api.getExportTalentCandidateProfilePdfTaskStatus(params)
  },
  getTalentCandidateExportExcelFieldInfo () {
    return api.getTalentCandidateExportExcelFieldInfo()
  },
  createTalentCandidateExportExcelInfoTask (context, params) {
    return api.createTalentCandidateExportExcelInfoTask(params)
  },
  copyTalentCandidate (context, params) {
    return api.copyTalentCandidate(params)
  },
  getTalentCandidateBaseInfo (context, { candidateId }) {
    return api.getTalentCandidateBaseInfo(candidateId)
  },
  getTalentCandidateResumeInfo (context, { candidateId }) {
    return api.getTalentCandidateResumeInfo(candidateId)
  },
  getTalentCandidateActivityInfo (context, { candidateId }) {
    return api.getTalentCandidateActivityInfo(candidateId)
  },
  getTalentCandidateTagInfo (context, params) {
    return api.getTalentCandidateTagInfo(params)
  },
  getTalentDuplicateCandidateList (context, { candidateId }) {
    return api.getTalentDuplicateCandidateList(candidateId)
  },
  getTalentCandidateSurveyInfo (context, { candidateId }) {
    return api.getTalentCandidateSurveyInfo(candidateId)
  },
  getTalentDuplicateCandidateIds (context, params) {
    return api.getTalentDuplicateCandidateIds(params)
  },
  getTalentResumeInfo (context, { candidateId }) {
    return api.getTalentResumeInfo(candidateId)
  },
  updateTalentResumeInfo (context, params) {
    return api.updateTalentResumeInfo(params)
  },
  updateTalentResumePhoto (context, { candidateId, photo }) {
    return api.updateTalentResumePhoto(candidateId, photo)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
